/**
 * CMS-side HubSpot tracking helper.
 *
 * - Loads the HubSpot tracking script (hs-scripts) for the configured portal id
 * - Ensures `window._hsq` exists so calls can be queued before the script loads
 * - Provides explicit allow-listed events to avoid accidental noisy tracking
 */

import { getPlatformBaseUrl } from "./platformUrl";

const DEFAULT_PORTAL_ID = "241913060";

function getPortalId() {
  const v = (process.env.REACT_APP_HUBSPOT_PORTAL_ID || "").trim();
  return v || DEFAULT_PORTAL_ID;
}

export function ensureHubspotLoaded() {
  if (typeof window === "undefined") return;

  // Queue must exist even before the script loads
  window._hsq = window._hsq || [];

  // If script already present, do nothing
  const portalId = getPortalId();
  const scriptId = `hs-script-loader-${portalId}`;
  if (document.getElementById(scriptId)) return;

  const s = document.createElement("script");
  s.id = scriptId;
  s.async = true;
  s.defer = true;
  s.type = "text/javascript";
  s.src = `https://js.hs-scripts.com/${portalId}.js`;
  document.head.appendChild(s);
}

function trackCustomBehavioralEvent(name, properties) {
  if (typeof window === "undefined") return;
  window._hsq = window._hsq || [];

  // Always ensure script is loading in the background
  ensureHubspotLoaded();

  window._hsq.push([
    "trackCustomBehavioralEvent",
    {
      name,
      properties: properties || {},
    },
  ]);
}

/**
 * HubSpot event: CMS admin created an event
 */
export function trackAdminEventCreated(props) {
  trackCustomBehavioralEvent("pe241913060_ng_platform_admin_event_created", {
    event_title: props?.event_title ?? null,
    event_description: props?.event_description ?? null,
    event_url: props?.event_url ?? null,
    platform_event_url: props?.platform_event_url ?? null,
    event_access_tier: props?.event_access_tier ?? null,
    event_image_url: props?.event_image_url ?? null,
    event_short_description: props?.event_short_description ?? null,
  });
}

export function buildPlatformEventUrl(eventId) {
  const id = Number(eventId || 0);
  if (!Number.isFinite(id) || id <= 0) return null;
  return `${getPlatformBaseUrl()}/events/${id}`;
}

